import LegalPage from "../components/LegalPage";

const TOC = [
  { id: "informacion", label: "¿Qué información recopilamos?" },
  { id: "uso", label: "¿Para qué utilizamos la información?" },
  { id: "seguridad", label: "Seguridad" },
  { id: "comparticion", label: "Compartición de información" },
  { id: "derechos", label: "Derechos del usuario" },
  { id: "cookies", label: "Cookies" },
  { id: "cambios", label: "Cambios al aviso" },
  { id: "contacto", label: "Contacto" },
];

export default function PrivacyPolicyPage() {
  return (
    <LegalPage title="Aviso de Privacidad" toc={TOC} testid="privacy-page">
      <p className="legal-lede">
        Mi Contador respeta la privacidad de sus usuarios y se compromete a proteger la información personal y empresarial que sea proporcionada dentro de la plataforma.
      </p>

      <section id="informacion">
        <h2>1. ¿Qué información recopilamos?</h2>
        <ul>
          <li>Nombre</li>
          <li>Correo electrónico</li>
          <li>RFC</li>
          <li>Información fiscal</li>
          <li>Información del negocio</li>
          <li>Datos de facturación</li>
          <li>Clientes</li>
          <li>Proveedores</li>
          <li>Documentos cargados por el usuario</li>
          <li>Información de pago</li>
          <li>Información de uso de la plataforma</li>
        </ul>
      </section>

      <section id="uso">
        <h2>2. ¿Para qué utilizamos la información?</h2>
        <ul>
          <li>Crear y administrar la cuenta.</li>
          <li>Generar facturas.</li>
          <li>Organizar información financiera.</li>
          <li>Preparar declaraciones.</li>
          <li>Mejorar la experiencia del usuario.</li>
          <li>Brindar soporte técnico.</li>
          <li>Cumplir obligaciones legales.</li>
          <li>Proteger la seguridad de la plataforma.</li>
        </ul>
      </section>

      <section id="seguridad">
        <h2>3. Seguridad</h2>
        <p>Toda la información se almacena utilizando conexiones cifradas y buenas prácticas de seguridad para proteger la confidencialidad de los datos.</p>
      </section>

      <section id="comparticion">
        <h2>4. Compartición de información</h2>
        <p>Mi Contador no vende la información personal de sus usuarios. Solo podrá compartirse cuando:</p>
        <ul>
          <li>Sea necesario para prestar el servicio.</li>
          <li>Exista autorización del usuario.</li>
          <li>Lo exija una autoridad competente conforme a la ley.</li>
        </ul>
      </section>

      <section id="derechos">
        <h2>5. Derechos del usuario</h2>
        <p>El usuario podrá solicitar:</p>
        <ul>
          <li>Acceso a su información.</li>
          <li>Corrección de datos.</li>
          <li>Eliminación de su cuenta.</li>
          <li>Exportación de sus datos.</li>
          <li>Revocar su consentimiento cuando sea aplicable.</li>
        </ul>
      </section>

      <section id="cookies">
        <h2>6. Cookies</h2>
        <p>La plataforma utiliza cookies necesarias para:</p>
        <ul>
          <li>Mantener la sesión iniciada.</li>
          <li>Recordar preferencias.</li>
          <li>Mejorar el funcionamiento del sitio.</li>
          <li>Analizar el uso de la plataforma.</li>
        </ul>
      </section>

      <section id="cambios">
        <h2>7. Cambios al aviso</h2>
        <p>Mi Contador podrá actualizar este Aviso de Privacidad. Cuando exista un cambio importante, se notificará al usuario dentro de la plataforma.</p>
      </section>

      <section id="contacto">
        <h2>8. Contacto</h2>
        <p>Para dudas relacionadas con privacidad: <a href="mailto:privacy@micontador.com">privacy@micontador.com</a></p>
      </section>
    </LegalPage>
  );
}
